/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from "react";
// Material Dashboard 2 React components
import {
  IconButton,
  TextField,
  Button,
  Alert,
  Icon,
  Box,
  Grid,
  Dialog,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Checkbox,
  ListItemButton,
  FormControl,
  MenuItem,
  InputLabel,
  Select,
  Snackbar,
} from "@mui/material";
import { Cancel, Close } from "@mui/icons-material";
import SaveIcon from "@mui/icons-material/Save";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { ThemeProvider } from "@mui/material/styles";
import { useMaterialUIController } from "context";
// import themeLight from "assets/theme";
// import themeDark from "assets/theme-dark";
import MDBox from "components/MDBox";
// import CssBaseline from "@mui/material/CssBaseline";
import { createTheme } from "@mui/material/styles";
import colors from "assets/theme/base/colors";
import { MenuProps } from "utils/constants";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
const defaultValue = {
  name: "",
  note: "",
  role_group: [],
  role_user: [],
  role_menu: [],
};

const CRUDRole = ({
  open,
  data,
  onClose,
  onSubmit,
  title,
  validationErrors,
  dataGroup,
  dataUser,
  dataMenu,
  dataGroupMenu,
}) => {
  const [controller, dispatch] = useMaterialUIController();
  const { darkMode } = controller;
  const [groupmenu, setGroupMenu] = useState(0);
  const [dataState, setDataState] = useState(defaultValue);
  const [optionMenu, setOptionMenu] = useState();
  const formRef = useRef(null);
  const axiosPrivateInstance = useAxiosPrivate();
  const [alert, setAlert] = useState({
    alert: false,
    message: null,
    type: null,
  });

  const themeLight = createTheme({
    palette: {
      primary: {
        main: colors.info.main,
      },
      background: {
        default: colors.background.default,
      },
      secondary: {
        main: colors.secondary.main,
      },
    },
  });
  const themeDark = createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: colors.info.main,
      },
      secondary: {
        main: colors.secondary.main,
      },
    },
  });

  useEffect(() => {
    if (data?.id) {
      setDataState(data);
      if (data["role_group"].length === 0) setCheckedItems_Group([]);
      else {
        const temp = data["role_group"].map((item) => item.id);
        setCheckedItems_Group(temp);
      }
      if (data["role_user"].length === 0) setCheckedItems_User([]);
      else {
        const temp = data["role_user"].map((item) => item.id);
        setCheckedItems_User(temp);
      }
      if (data["role_menu"].length === 0) setCheckedItems_Menu([]);
      else {
        const temp = data["role_menu"].map((item) => item.id);
        setCheckedItems_Menu(temp);
      }
    } else {
      setDataState(defaultValue);
      setCheckedItems_Group([]);
      setCheckedItems_User([]);
      setCheckedItems_Menu([]);
    }
  }, [data]);

  const [checkedItems_Group, setCheckedItems_Group] = useState([]);
  const handleToggle_Group = (value) => () => {
    const currentIndex = checkedItems_Group.indexOf(value);
    const newChecked = [...checkedItems_Group];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setCheckedItems_Group(newChecked);
  };

  const [checkedItems_User, setCheckedItems_User] = useState([]);
  const handleToggle_User = (value) => () => {
    const currentIndex = checkedItems_User.indexOf(value);
    const newChecked = [...checkedItems_User];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setCheckedItems_User(newChecked);
  };
  const [checkedItems_Menu, setCheckedItems_Menu] = useState([]);
  const handleToggle_Menu = (value) => () => {
    const currentIndex = checkedItems_Menu.indexOf(value);
    const newChecked = [...checkedItems_Menu];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setCheckedItems_Menu(newChecked);
  };
  const handleChange = (e) => {
    let { value } = e.target;
    getMenu(value);
  };
  const getMenu = async (id) => {
    try {
      const response = await axiosPrivateInstance.get("menu?group=" + id);
      setOptionMenu(response.data);
    } catch (error) {
      return;
    }
  };
  const [errors, setErrors] = useState({
    name: "",
    role_group: [],
    role_user: [],
    role_menu: [],
  });
  async function onSubmitForm(event) {
    event.preventDefault();
    const _data = { ...dataState };
    _data["id"] = data?.id;
    _data["rowIndex"] = data?.rowIndex;
    _data["role_group"] = checkedItems_Group;
    _data["role_user"] = checkedItems_User;
    _data["role_menu"] = checkedItems_Menu;
    const newValidationErrors = validateOBJ(_data);
    let _tempValid = newValidationErrors;

    if (Object.values(_tempValid).some((error) => error)) {
      setErrors(newValidationErrors);
      return;
    }
    onSubmit(_data);
    setErrors({});
  }

  const handelClear = () => {
    onClose();
    setErrors([]);
  };

  useEffect(() => {
    if (validationErrors?.another) {
      setAlert({
        alert: true,
        message: validationErrors?.another,
        type: "error",
      });
    } else {
      setErrors(validationErrors);
    }
  }, [validationErrors]);

  useEffect(() => {
    if (open) {
      setOptionMenu(dataMenu);
      setErrors([]);
    }
  }, [open]);
  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ alert: false, message: null, type: null });
  };

  const handleOnFocus = (name) => (e) => {
    e.stopPropagation();
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleChangeValueInput = (name) => (e) => {
    let { value } = e.target;
    setDataState((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  return (
    // <ThemeProvider theme={darkMode ? themeDark : themeLight}>
    <Dialog open={open} maxWidth={"md"}>
      <form ref={formRef} method="post" encType="multipart/form-data">
        <DialogTitle sx={{ m: 0, p: 2 }}>
          {title ? title : "Danh sách Quyền"}
          <IconButton
            aria-label="close"
            onClick={handelClear}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        {alert.alert && (
          <Snackbar
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={alert.alert}
            onClose={handleCloseAlert}
          >
            <Alert onClose={handleCloseAlert} severity={alert.type}>
              {alert.message}
            </Alert>
          </Snackbar>
        )}
        <DialogContent dividers>
          <MDBox sx={{ p: 1 }}>
            {errors && errors.error ? (
              <Grid container sx={{ textAlign: "center", mb: 0 }}>
                <Grid item xs={12}>
                  <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                    {errors.error}
                  </Alert>
                </Grid>
              </Grid>
            ) : (
              ""
            )}
            <Grid container spacing={2} sx={{ textAlign: "left" }}>
              <Grid item xs={12} md={12} lg={12}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Tên Quyền <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  value={dataState.name || ""}
                  sx={{ width: "100%" }}
                  name="name"
                  error={errors ? !!errors.name : false}
                  helperText={errors.name}
                  onFocus={handleOnFocus("name")}
                  onChange={handleChangeValueInput("name")}
                  placeholder="Nhập Tên quyền"
                  inputProps={{ maxLength: 255 }}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Ghi chú
                </Typography>
                <TextField
                  fullWidth
                  name="note"
                  error={errors ? !!errors.note : false}
                  helperText={errors?.note}
                  value={dataState ? dataState.note : ""}
                  onChange={handleChangeValueInput("note")}
                  onFocus={() => {
                    setErrors({
                      ...errors,
                      note: "",
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <Paper
                  sx={{
                    width: "100%",
                    height: 370,
                    overflow: "auto",
                    paddingRight: "10px",
                  }}
                >
                  <Typography
                    color="info"
                    sx={{
                      backgroundColor: "#1b73e8",
                      color: "#ffff",
                      fontSize: "1rem",
                    }}
                  >
                    Nhóm người dùng
                  </Typography>
                  <List
                    dense
                    component="div"
                    role="list"
                    sx={{ width: "100%", bgcolor: "background.paper" }}
                  >
                    {dataGroup &&
                      dataGroup?.length > 0 &&
                      dataGroup.map((value) => {
                        const labelId = `${value.id}`;
                        return (
                          <ListItem key={value.id} disablePadding>
                            <ListItemButton
                              role={undefined}
                              onClick={handleToggle_Group(value.id)}
                              dense
                            >
                              <ListItemIcon>
                                <Checkbox
                                  edge="start"
                                  checked={
                                    checkedItems_Group.indexOf(value.id) !== -1
                                  }
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{ "aria-labelledby": labelId }}
                                />
                              </ListItemIcon>
                              <ListItemText
                                id={labelId}
                                primary={`${value.name}`}
                              />
                            </ListItemButton>
                          </ListItem>
                        );
                      })}
                  </List>
                </Paper>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <Paper
                  sx={{
                    width: "100%",
                    height: 370,
                    overflow: "auto",
                    paddingRight: "10px",
                  }}
                >
                  <Typography
                    color="info"
                    sx={{
                      backgroundColor: "#1b73e8",
                      color: "#ffff",
                      fontSize: "1rem",
                    }}
                  >
                    Phân quyền người dùng
                  </Typography>
                  <List
                    dense
                    component="div"
                    role="list"
                    sx={{ width: "100%", bgcolor: "background.paper" }}
                  >
                    {dataUser &&
                      dataUser?.length > 0 &&
                      dataUser.map((value) => {
                        const labelId = `${value.id}`;
                        return (
                          <ListItem key={value.id} disablePadding>
                            <ListItemButton
                              role={undefined}
                              onClick={handleToggle_User(value.id)}
                              dense
                            >
                              <ListItemIcon>
                                <Checkbox
                                  edge="start"
                                  checked={
                                    checkedItems_User.indexOf(value.id) !== -1
                                  }
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{ "aria-labelledby": labelId }}
                                />
                              </ListItemIcon>
                              <ListItemText
                                id={labelId}
                                primary={`${value.first_name} ${value.last_name}`}
                              />
                            </ListItemButton>
                          </ListItem>
                        );
                      })}
                  </List>
                </Paper>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <Typography
                  color="info"
                  sx={{
                    backgroundColor: "#1b73e8",
                    color: "#ffff",
                    fontSize: "1rem",
                  }}
                >
                  Phân quyền chức năng
                </Typography>
                <Typography
                  color="info"
                  sx={{ color: "#000", fontSize: "1rem" }}
                >
                  Nhóm chức năng
                </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    sx={{ padding: "0.7rem" }}
                    labelId="label-loai"
                    defaultValue={groupmenu}
                    MenuProps={MenuProps}
                    onChange={handleChange}
                  >
                    <MenuItem value="0">Tất cả</MenuItem>
                    {dataGroupMenu &&
                      dataGroupMenu?.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                <Paper
                  sx={{
                    width: "100%",
                    height: 280,
                    overflow: "auto",
                    paddingRight: "10px",
                  }}
                >
                  <List
                    dense
                    component="div"
                    role="list"
                    sx={{ width: "100%", bgcolor: "background.paper" }}
                  >
                    {optionMenu &&
                      optionMenu?.length > 0 &&
                      optionMenu.map((value) => {
                        const labelId = `${value.id}`;
                        return (
                          <ListItem key={value.id} disablePadding>
                            <ListItemButton
                              role={undefined}
                              onClick={handleToggle_Menu(value.id)}
                              dense
                            >
                              <ListItemIcon>
                                <Checkbox
                                  edge="start"
                                  checked={
                                    checkedItems_Menu.indexOf(value.id) !== -1
                                  }
                                  tabIndex={-1}
                                  disableRipple
                                  inputProps={{ "aria-labelledby": labelId }}
                                />
                              </ListItemIcon>
                              <ListItemText
                                id={labelId}
                                primary={`${value.name}`}
                              />
                            </ListItemButton>
                          </ListItem>
                        );
                      })}
                  </List>
                </Paper>
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            type="button"
            variant="contained"
            startIcon={<Cancel />}
            size="small"
            onClick={handelClear}
            sx={{ color: "#ffffff", float: "right", mr: 1 }}
          >
            Hủy
          </Button>
          <Button
            type="submit"
            variant="contained"
            startIcon={<SaveIcon />}
            size="small"
            onClick={onSubmitForm}
            sx={{ color: "#ffffff", float: "right", mr: 1 }}
          >
            Lưu
          </Button>
        </DialogActions>
      </form>
    </Dialog>
    // </ThemeProvider>
  );
};
const validateRequired = (value) => !!value.length;

function validateOBJ(user) {
  return {
    name: !validateRequired(user.name) ? "Tên quyền không được trống" : "",
  };
}

export default CRUDRole;
